import React from 'react'

import { Router } from '@reach/router'

import List from 'src/components/news/list'
import Article from 'src/components/news/article'
import ReadyToGo from 'src/components/readytogo/index'

import styles from './index.module.scss'


const NewsPage = () => {
    return (
        <React.Fragment>
            <div className={styles.news}>
                <Router basepath="/news">
                    <Article path="/:slug" />
                    <List path="/" />
                </Router>
            </div>

            <ReadyToGo />
        </React.Fragment>
    )
}

export default NewsPage
